import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { ClipboardList } from 'lucide-react';
import DailyPickupReportCard from '../DailyPickupReportCard';

export default function AdminDailyReportsTab({ properties, dailyReports }) {
  return (
    <>
      <DailyPickupReportCard
        propertyOptions={properties}
        defaultPropertyId={properties?.[0]?.property_id}
        dataTestId="admin-daily-report-card"
      />
      <Card className="bg-zinc-900 border-2 border-[#FFD60A]/40 p-6" data-testid="daily-reports-tab">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              DAILY REPORTS
            </h2>
            <p className="text-sm text-zinc-400">Supervisor and Crew Leader daily checklists</p>
          </div>
          <Badge className="bg-[#FFD60A] text-black" data-testid="daily-reports-count">
            {dailyReports.length} Reports
          </Badge>
        </div>

        {dailyReports.length === 0 ? (
          <div className="text-center py-10" data-testid="daily-reports-empty">
            <ClipboardList className="h-12 w-12 text-zinc-600 mx-auto mb-3" />
            <p className="text-zinc-400">No daily reports yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {dailyReports.map((report) => {
              const completedCount = Object.values(report.checklist || {}).filter(Boolean).length;
              return (
                <Card
                  key={report.report_id}
                  className="bg-zinc-800 border-zinc-700 p-4"
                  data-testid={`daily-report-row-${report.report_id}`}
                >
                  <div className="flex flex-wrap items-start justify-between gap-4">
                    <div>
                      <p className="text-white font-semibold">{report.property_name}</p>
                      <p className="text-xs text-zinc-400">
                        {report.report_date} • {report.hours_worked} hrs
                      </p>
                      <p className="text-xs text-zinc-500">
                        {report.user_name} • Badge {report.badge_number}
                      </p>
                    </div>
                    <Badge className="bg-[#FFD60A] text-black" data-testid={`daily-report-items-${report.report_id}`}>
                      {completedCount} items checked
                    </Badge>
                  </div>
                  {report.notes && (
                    <p className="text-xs text-zinc-400 mt-2" data-testid={`daily-report-notes-${report.report_id}`}>
                      Notes: {report.notes}
                    </p>
                  )}
                </Card>
              );
            })}
          </div>
        )}
      </Card>
    </>
  );
}
